module.exports = __webpack_public_path__ + "img/rep-manny.8d3fca18.png";